module.exports = __webpack_public_path__ + "static/media/affordable-catering-3.ff641357.jpg";